var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { container, ENV_KEY, HttpAction, IfAction, NavigateAction, ToastAction, Query, ModalAction, ResetAction, ValidateAction, SubmitAction, } from "@al/aku-lc-core";
import { each, isFn } from "@al/aku-lc-helpers";
import { actionBuilder } from "./builders";
var transformActionRunAfter = function (runAfter) {
    var result = {};
    each(runAfter, function (actions, key) {
        result[key] = [];
        actions === null || actions === void 0 ? void 0 : actions.forEach(function (actionPath) {
            /* eslint-disable-next-line prefer-const */
            var _a = actionPath.split(/\s*\/actions\s*/), widgetPath = _a[0], partialActionPath = _a[1];
            if (!widgetPath) {
                widgetPath = "/";
            }
            var fn = function () {
                // TODO: 是否可以缓存
                var env = container.resolve(ENV_KEY);
                if (env) {
                    var target = new Query(widgetPath, "actions" + partialActionPath).get();
                    target === null || target === void 0 ? void 0 : target.execute();
                }
            };
            result[key].push(fn);
        });
    });
    return result;
};
var buildHttpAction = function (key, inputs, options, evaluate) {
    return new HttpAction({
        path: key,
        type: "Http",
        payload: transformHttpPayload(inputs, options, evaluate),
    });
};
var buildToastAction = function (key, inputs, options, evaluate) {
    return new ToastAction({
        path: key,
        type: "Toast",
        payload: transformToastPayload(inputs, options, evaluate),
    });
};
var buildIfAction = function (key, inputs, options, evaluate) {
    return new IfAction({
        path: key,
        type: "If",
        payload: transformIfPayload(key, inputs, options, evaluate),
    });
};
var buildNavigateAction = function (key, inputs, options, evaluate) {
    return new NavigateAction({
        path: key,
        type: "Navigate",
        payload: transformNavigatePayload(inputs, options, evaluate),
        status: "Pending",
    });
};
var buildOpenModalAction = function (key, inputs) {
    return new ModalAction({
        path: key,
        type: "OpenModal",
        payload: {
            type: "open",
            target: inputs.target,
        },
        status: "Pending",
    });
};
var buildCloseModalAction = function (key, inputs) {
    return new ModalAction({
        path: key,
        type: "CloseModal",
        payload: {
            type: "close",
            target: inputs.target,
        },
        status: "Pending",
    });
};
var buildValidateAction = function (key, inputs) {
    return new ValidateAction({
        path: key,
        type: "Validate",
        payload: {
            target: inputs.target,
            isForm: inputs.isForm,
        },
        status: "Pending",
    });
};
var buildResetAction = function (key, inputs) {
    return new ResetAction({
        path: key,
        type: "Reset",
        payload: {
            target: inputs.target,
            isForm: inputs.isForm,
        },
        status: "Pending",
    });
};
var buildSubmitAction = function (key, inputs) {
    return new SubmitAction({
        path: key,
        type: "Submit",
        payload: {
            target: inputs.target,
        },
        status: "Pending",
    });
};
export var buildAction = function (option) {
    var action = option.action, key = option.key, options = option.options, evaluate = option.evaluate;
    var inputs = action.inputs;
    if (!action.inputs) {
        return;
    }
    var result;
    switch (action.type) {
        case "If": {
            result = buildIfAction(key, inputs, options, evaluate);
            break;
        }
        case "Navigate":
            result = buildNavigateAction(key, inputs, options, evaluate);
            break;
        case "Http":
            result = buildHttpAction(key, inputs, options, evaluate);
            break;
        case "OpenModal":
            result = buildOpenModalAction(key, inputs);
            break;
        case "CloseModal":
            result = buildCloseModalAction(key, inputs);
            break;
        case "Validate":
            result = buildValidateAction(key, inputs);
            break;
        case "Toast":
            result = buildToastAction(key, inputs, options, evaluate);
            break;
        case "Reset":
            result = buildResetAction(key, inputs);
            break;
        case "Submit":
            result = buildSubmitAction(key, inputs);
            break;
        default:
            break;
    }
    if (result && action.runAfter) {
        result.runAfter = transformActionRunAfter(action.runAfter);
    }
    if (result && action.inject) {
        result.inject = action.inject;
    }
    return result;
};
var transformIfPayload = function (key, inputs, options, evaluate) {
    var when = evaluate(inputs === null || inputs === void 0 ? void 0 : inputs.when, options.context);
    var fulfill;
    var otherwise;
    if (inputs === null || inputs === void 0 ? void 0 : inputs.fulfill) {
        fulfill = buildAction({ key: key + "/fulfill", action: inputs === null || inputs === void 0 ? void 0 : inputs.fulfill, options: options, evaluate: evaluate });
    }
    if (inputs === null || inputs === void 0 ? void 0 : inputs.otherwise) {
        otherwise = buildAction({
            key: key + "/otherwise",
            action: inputs === null || inputs === void 0 ? void 0 : inputs.otherwise,
            options: options,
            evaluate: evaluate,
        });
    }
    return {
        when: when,
        fulfill: fulfill,
        otherwise: otherwise,
    };
};
var transformNavigatePayload = function (inputs, options, evaluate) {
    var _a;
    var origQuery = (inputs === null || inputs === void 0 ? void 0 : inputs.query) || {};
    var query = {};
    Object.keys(origQuery).forEach(function (key) {
        query[key] = evaluate(origQuery[key], options.context);
    });
    return {
        uri: evaluate(inputs.uri, options.context),
        query: query,
        target: (_a = inputs) === null || _a === void 0 ? void 0 : _a.target,
    };
};
var transformHttpPayload = function (inputs, options, evaluate) {
    var data = {};
    var headers = {};
    if (inputs === null || inputs === void 0 ? void 0 : inputs.data) {
        each(inputs === null || inputs === void 0 ? void 0 : inputs.data, function (value, key) {
            data[key] = evaluate(value, options.context);
        });
    }
    if (inputs === null || inputs === void 0 ? void 0 : inputs.headers) {
        each(inputs === null || inputs === void 0 ? void 0 : inputs.headers, function (value, key) {
            headers[key] = evaluate(value, options.context);
        });
    }
    return {
        url: evaluate(inputs.url, options.context),
        method: evaluate(inputs.method, options.context),
        crossOrigin: inputs.crossOrigin,
        data: data,
        headers: headers,
    };
};
var transformToastPayload = function (inputs, options, evaluate) {
    return __assign(__assign({}, inputs), { message: evaluate(inputs.message, options.context) });
};
function tranformPayload(option) {
    var key = option.key, action = option.action, options = option.options, evaluate = option.evaluate;
    var inputs = action.inputs;
    if (!action.inputs) {
        return;
    }
    switch (action.type) {
        case "If": {
            return transformIfPayload(key, inputs, options, evaluate);
        }
        case "Navigate": {
            return transformNavigatePayload(inputs, options, evaluate);
        }
        case "Http":
            return transformHttpPayload(inputs, options, evaluate);
        case "OpenModal":
        case "CloseModal":
        case "Validate":
        case "Toast":
            return transformToastPayload(inputs, options, evaluate);
        case "ResetForm":
        case "Submit":
        default:
            break;
    }
}
export function transformActionsPayload(actions, options, evaluate) {
    var transformed = {};
    each(actions, function (value, key) {
        var payload = tranformPayload({ action: value, key: key, options: options, evaluate: evaluate });
        if (payload) {
            transformed[key] = payload;
        }
    });
    return transformed;
}
export function transformActions(actions, options, evaluate) {
    var transformed = {};
    each(actions, function (value, key) {
        var action = (isFn(actionBuilder) &&
            actionBuilder({
                action: value,
                key: key,
                rootOptions: options,
                evaluate: evaluate,
                transformActionRunAfter: transformActionRunAfter,
            })) ||
            buildAction({ action: value, key: key, options: options, evaluate: evaluate });
        if (action) {
            transformed[key] = action;
        }
    });
    return transformed;
}
